import React, { useState, useEffect } from "react";
import downloadIcon from "../../../../../Assets/icons/download.svg";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import addIcon from "../../../../../Assets/icons/addIconLogistics.svg";
import deleteIcon from "./../../../../../Assets/icons/trash.svg";
import { useAsyncError, useNavigate } from "react-router-dom";
import CustomTable from "../../../../customComponents/CustomTable";
import axiosInstance from "../../../../services/api/API";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import "./PhysicalStockin.scss";

import Drawer from "react-modern-drawer";

import "react-modern-drawer/dist/index.css";
import Vehicle from "../PhysicalStockinComponents/Vehicle";
import SparePart from "../PhysicalStockinComponents/SparePart";
import Accesories from "../PhysicalStockinComponents/Accesories";
import Serial from "../PhysicalStockinComponents/Serial";
import CustomLogisticsTable from "../../CustomLogisticsTable";
import ROUTES_NAVIGATION from "../../../../../routes/routes";

const PhysicalStockin = ({ stockTypesData, PhysicalStockinId, vendorId, businessPartnerIdState }) => {
  const [formData, setFormData] = useState({});
  const [serialformData, setserialFormData] = useState({});
  const [physicalStockData, setphysicalStockData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [activeComponent, setActiveComponent] = useState("vehicle");
  const [phyItemId, setPhyItemId] = useState(0);
  const [serialDrawer, setSerialDrawer] = useState(false);
  const [itemType,setItemType] = useState("")

  const [isSerailDrawerOpen, setIsSerialDrawerOpen] = useState(false);
  const [serialData,setSerialData] = useState([])

  const [ itemNameData, setItemNameData ] = useState("")

  console.log(vendorId, "vendorId");

  console.log(businessPartnerIdState, "PARTNERIDSTATE")

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
    if(isEdit){
      setIsEdit(!isEdit)
    }
    setFormData({})
    
  };

  const handleFormSubmit = () => {
    console.log("clicked")
  }

  const toggleSerialDrawer = () => {
    console.log("isSerailDrawerOpen",isSerailDrawerOpen);
    setFormData({})
    setIsSerialDrawerOpen((prevState) => !prevState);
    
    
  };
  console.log("isSerailDrawerOpen",isSerailDrawerOpen);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDepartments(newPage);
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async (page = 0, pageSize = 10) => {
    try {
      const response = await axiosInstance.post(
        "/physicalstocktakeitem/list",
        {
          orderBy: "phystkin_item_id desc",
          page,
          pageSize,
          itemtype: null,
          phystkin_id: PhysicalStockinId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);

      // const itemNameType = response?.data?.data?.data?.itemtypename
      // console.log(itemNameType, "ITEMNAMETYPEDATA")
      // setItemNameData(itemNameType)

      setphysicalStockData(formattedData);
      console.log("response", response);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };
 
  // Table headers
  const DEPARTMENT_TABLE_HEADERS = [
    // "Sr No.",
    // "Department ID",
    "Variant Name",
    "Item Name",
    "Item Type",
    "Make",
    "Model",
    "Price",
    "Goods Quantity",
    "Total Price",
    "Action",
  ];

  // Key mapping for CustomTable component
  const DEPARTMENT_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    // "Department ID": "department_id",
    "Variant Name": "variant_name",
    "Item Name": "item_name",
    "Item Type": "itemtypename",
    Make: "make_name",
    Model: "model_name",
    Price: "rate",
    "Goods Quantity": "good_qty",
    "Total Price": "total_price",
    Action: [
      { type: "edit", icon: editIcon, label: "Edit" },
      //{ type: "delete", icon: deleteIcon, label: "Delete" },
      { type: "addserial", icon: addIcon, label: "Add" },
    ],
  };
  const handleEdit = (rowData) => {
    console.log("rowData>>", rowData);
    setPhyItemId(rowData?.phystkin_item_id);
    setItemNameData(rowData?.itemtypename)
    console.log(rowData?.itemtypename, "ITEMNAMEDATATYPE")
    setIsEdit(true);
    if (rowData?.itemtype === "V") {
      setItemType("vehicle")
      setActiveComponent("vehicle");
    } else if (rowData?.itemtype === "A") {
      setItemType("accessory")
      setActiveComponent("accessory");
    } else {
      setItemType("spareaparts")
      setActiveComponent("spareparts");
    }    toggleDrawer(); // Open the drawer
  };
  const handleAddSerial = (rowData) => {
    console.log("rowData>>", rowData);
    setSerialData(rowData)
    setPhyItemId(rowData?.phystkin_item_id);
    setItemNameData(rowData?.itemtypename)
 

    setSerialDrawer(true);
    toggleSerialDrawer(); 
  };
  console.log("activeComponent", activeComponent);

  const handleDelete = async (rowData) => {
    console.log("rowData>>>>", rowData);

    try {
      const response = await axiosInstance.delete(
        `/physicalstocktakeitem/delete/${rowData.phystkin_item_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Create a new array without the deleted item
        const updatedData = physicalStockData.filter(
          (item) => item.phystkin_item_id !== rowData.phystkin_item_id
        );
        setphysicalStockData(updatedData);
        console.log("Item deleted successfully");
      } else {
        console.error("Failed to delete item");
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  return (
    <div style={{paddingTop:"14px"}}>
      <div className="logisticsTableWrapper">
        <div className="logisticsadmin-list-container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              /* padding-left: 20px; */ gap: "20px",
            }}
          >
            <h5>Physical Stock-in</h5>
            <div className="searchinput-wrapper">
              <input
                type="text"
                className="searchinput"
                placeholder="Search Departments"
                value={searchTerm}
                onChange={handleSearchInputChange}
              />
              {/* <img src={searchIcon} alt="Search" className="searchinput-icon" /> */}
            </div>
          </div>
          <div>
            {stockTypesData?.length>0 ? 
              <button className="addcustomerbutton" 
              onClick={() => {
               setIsEdit(false);
               setFormData({})
               toggleDrawer();
             }}>
               Add Logistic Type
             </button>:<span>No Stock Available</span>}
          
          </div>
        </div>

        <Drawer
          size={600}
          open={isOpen}
          onClose={toggleDrawer}
          direction="right"
          className="bla bla bla"
        >
          <div style={{ padding: "30px" }}>
            <div className="backbutton" onClick={()=>toggleDrawer()}>
              <img src={backicon} alt="back" />

             {stockTypesData?.length>0 ? <span className="backbtntitleDetails">Add Logistic Type </span>: <span className="backbtntitleDetails">No Stock Available </span>}
            </div>

            <div>
              <div
                className="d-flex jus align-items-center pt-3 flex-row gap-4"
                style={{ paddingLeft: "20px" }}
              >
                {stockTypesData?.length>0 && stockTypesData?.map((type, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "8px",
                    }}
                    onClick={() => {
                      setActiveComponent(type);
                    }}
                  >
                    <input
                      type="radio"
                      name="activeComponent"
                      checked={activeComponent === type}
                      onChange={() => setActiveComponent(type)}
                      className="form-check-input"
                    />
                    {type.charAt(0).toUpperCase() + type.slice(1)}{" "}
                    {/* Capitalize the first letter */}
                  </div>
                ))}
              </div>
              {stockTypesData && <div style={{ paddingLeft: "20px" }}>
                {activeComponent === "vehicle" && (
                  <div className="mt-3">
                    <Vehicle
                      PhysicalStockinId={PhysicalStockinId}
                      vendorId={vendorId}
                      fetchDepartments={fetchDepartments}
                      isEdit={isEdit}
                      formData={formData}
                      setFormData={setFormData}
                      phyItemId={phyItemId}
                      activeComponent={"vehicle"}
                      toggleDrawer={toggleDrawer}
                      businessPartnerIdState={businessPartnerIdState}
                    />
                  </div>
                )}
                {activeComponent === "spareparts" && (
                  <div className="mt-3">
                    <SparePart
                      PhysicalStockinId={PhysicalStockinId}
                      vendorId={vendorId}
                      fetchDepartments={fetchDepartments}
                      isEdit={isEdit}
                      toggleDrawer={toggleDrawer}
                      phyItemId={phyItemId}
                      setIsEdit={setIsEdit}
                      formData={formData}
                      setFormData={setFormData}
                      businessPartnerIdState={businessPartnerIdState}
                    />
                  </div>
                )}
                {activeComponent === "accessory" && (
                  <div className="mt-3">
                    <Accesories
                      PhysicalStockinId={PhysicalStockinId}
                      vendorId={vendorId}
                      fetchDepartments={fetchDepartments}
                      isEdit={isEdit}
                      toggleDrawer={toggleDrawer}
                      phyItemId={phyItemId}
                      setIsEdit={setIsEdit}
                      businessPartnerIdState={businessPartnerIdState}
                    />
                  </div>
                )}
              </div>}    
            </div>
          </div>
        </Drawer>
        {serialDrawer && (
          <Drawer
            size={800}
            open={isSerailDrawerOpen}
            onClose={toggleSerialDrawer}
            direction="right"
            className="bla bla bla"
          >
            <div style={{ padding: "30px" }}>
              <div className="backbutton" onClick={()=>toggleSerialDrawer()}>
                <img src={backicon} alt="back" />
                <span className="backbtntitleDetails">
                  Add Factory Stock-In Serial 
                </span>
              </div>

              <div className="mt-3">
                <Serial
                  PhysicalStockinId={PhysicalStockinId}
                  vendorId={vendorId}
                  fetchDepartments={fetchDepartments}
                  isEdit={isEdit}
                  isSerailDrawerOpen={isSerailDrawerOpen}
                  toggleSerialDrawer={toggleSerialDrawer}
                  phyItemId={phyItemId}
                  serialData={serialData}
                  setIsEdit={setIsEdit}
                  formData={formData}
                  setFormData={setFormData}
                  // itemNameData={itemNameData}
                  itemNameData={itemNameData}
                  businessPartnerIdState={businessPartnerIdState}
                />
              </div>
              <hr />
            
            </div>
          </Drawer>
        )}

        <CustomLogisticsTable
          data={physicalStockData}
          headers={DEPARTMENT_TABLE_HEADERS}
          keyMapping={DEPARTMENT_KEY_MAPPING}
          itemsPerPage={10}
          totalRecords={totalRecords} 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onDelete={handleDelete}
          onEdit={handleEdit}
          onAddSerial={handleAddSerial}
          
        />
      </div>
    </div>
  );
};

export default PhysicalStockin;
